export class MissingSessionError extends Error {
  constructor() {
    super('Missing session identifier for punchout authentication.');
    this.name = 'MissingSessionError';
  }
}
